import { useEffect, useState } from 'react';
import { getUser, isAuthenticated, login as doLogin, logout as doLogout, onAuthChange, } from '@/lib/auth';
/** Subscribe to auth changes so any view re-renders on login/logout/refresh. */
export function useAuth() {
    const [, setTick] = useState(0);
    useEffect(() => onAuthChange(() => setTick((n) => n + 1)), []);
    return {
        authenticated: isAuthenticated(),
        user: getUser(),
        login: doLogin,
        logout: doLogout,
    };
}
